
import type {Root} from 'mdast';
import {Plugin} from 'unified';
import {visit} from 'unist-util-visit';

// A custom void is a tag like:
// <x-abc a="1" b="2" />
//
// That we rewrite to:
// <x-abc a="1" b="2"></x-abc>
const customVoid = /^<(?<tag>x-[a-z0-9-]+)\s*(?<props>[^</>]*)\s*\/>$/;

const remarkCustomVoids: Plugin<void[], Root> = () => {
	return (tree) => {
		visit(tree, 'html', (node, index, parent) => {
			if (!index || !parent) {
				return;
			}

			const m = node.value.match(customVoid);
			if (!m) {
				return;
			}

			const {tag, props} = m.groups || {};
			const value = props ? `<${tag} ${props}></${tag}>` : `<${tag}></${tag}>`;

			parent.children[index] = {...node, value};
		});
	};
};

export default remarkCustomVoids;
